import { ITableFilter } from '@logicalcommander/types'
import { Middleware } from '@reduxjs/toolkit'

export const TABLE_FILTER_SESSION_KEY = 'lc-table-header-filters'
const RESET_AUTH = 'authReducer/resetState'
const CLEAR_APPLIED_FILTERS = 'filtersReducer/clearAppliedFilters'

let persistEnabled = false

export const readSessionTableFilters = (): ITableFilter[] | null => {
  try {
    const raw = sessionStorage.getItem(TABLE_FILTER_SESSION_KEY)
    if (!raw) {
      return null
    }
    const parsed: unknown = JSON.parse(raw)
    return Array.isArray(parsed) ? (parsed as ITableFilter[]) : null
  } catch {
    return null
  }
}

export const clearSessionTableFilters = (): void => {
  try {
    sessionStorage.removeItem(TABLE_FILTER_SESSION_KEY)
  } catch {
    // sessionStorage can throw in private mode
  }
}

export const enableTableFilterPersistence = (): void => {
  persistEnabled = true
}

export const disableTableFilterPersistence = (): void => {
  persistEnabled = false
}

const writeSessionTableFilters = (filters: ITableFilter[]): void => {
  if (!persistEnabled) {
    return
  }
  try {
    sessionStorage.setItem(TABLE_FILTER_SESSION_KEY, JSON.stringify(filters))
  } catch {
    // sessionStorage can throw in private mode
  }
}

export const tableFilterSessionMiddleware: Middleware = (storeApi) => (next) => (action) => {
  const result = next(action)
  const type = typeof action === 'object' && action !== null && 'type' in action ? String((action as { type: unknown }).type) : ''
  if (type === RESET_AUTH) {
    disableTableFilterPersistence()
    clearSessionTableFilters()
    storeApi.dispatch({ type: CLEAR_APPLIED_FILTERS })
    return result
  }
  if (type === CLEAR_APPLIED_FILTERS) {
    return result
  }
  const header = (storeApi.getState() as { filtersReducer: { tableHeader: ITableFilter[] } }).filtersReducer.tableHeader
  writeSessionTableFilters(header)
  return result
}
